import {useToast} from "~/composables/useToast.js";
const modalStatus = ref(false)

export function useProfile() {
    const user = useState("auth");
    const { showToast } = useToast()


    const fullName = ref('')
    const currentPass = ref('')
    const newPass = ref('')

    const loading = reactive({
        account: false,
        password: false,
    })
    const error = reactive({
        account: [],
        password: [],
    })


    const canChangeName = computed(() => fullName.value.trim() && fullName.value.trim() !== user.value.displayName.trim())
    const canChangePass = computed(() => currentPass.value.trim() && newPass.value.trim())


    async function changeAccount(){
        if (!canChangeName.value) return
        error.account = []
        if (fullName.value.trim().length > 20) {
            error.account.push('نام کامل حداکثر 20 کاراکتر میتواند باشد.')
            return
        }

        loading.account = true
       const {data, error: apiError} = await useApi('/v1/profile', {
           method: 'PUT',
           body: {
               'display_name': fullName.value
           }
       })
        loading.account = false

        if (apiError.value){
            error.account.push(apiError.value.message || 'خطایی رخ داد، لطفا مجددا تلاش کنید')
            return false;
        }
        error.account = []
        modalStatus.value = false
        user.value.displayName = fullName.value.trim()
        showToast('موفق', 'نام کامل شما با موفقیت ویرایش شد.')
    }
    async function changePassword(){
        if (!canChangePass.value) return
        error.password = []
        if (newPass.value.trim() === currentPass.value.trim()) {
            error.password.push('رمز عبور جدید باید با رمز فعلی متفاوت باشد')
            newPass.value = ''
            currentPass.value = ''
            return
        } else if (newPass.value.trim().length < 8) {
            error.password.push('رمز عبور جدید باید حداقل 8 کاراکتر باشد')
            return
        }


        loading.password = true
        const { error: e } = await useApi("/v1/auth/update-password", {
            method: "POST",
            body: {
                "old_password": currentPass.value.trim(),
                "new_password": newPass.value.trim(),
                "new_password_confirmation": newPass.value.trim()
            }
        })
        loading.password = false

        if (e.value){
            error.password.push(e.value.message || 'خطایی رخ داد، لطفا مجددا تلاش کنید')
            return false;
        }
        error.password = []
        modalStatus.value = false
        showToast('موفق', 'رمز عبور شما با موفقیت تغییر یافت.')
    }


    return {
        fullName,
        currentPass,
        newPass,
        loading,
        modalStatus,
        error,


        canChangeName,
        canChangePass,


        changeAccount,
        changePassword
    }
}